(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["limitless-product-conversion"] && !Shopify.designMode) return;
  try {
    
function bindLimitlessProducts(){document.querySelectorAll('[data-lb-product]').forEach(root=>{if(root.dataset.bound)return;root.dataset.bound='true';const select=root.querySelector('[data-lb-variant]');const update=()=>{const option=select.options[select.selectedIndex];const available=option.dataset.available==='true';root.querySelector('[data-lb-price]').textContent=option.dataset.price;const button=root.querySelector('[data-lb-add]');button.disabled=!available;button.textContent=root.querySelector(available?'[data-lb-label-add]':'[data-lb-label-sold]').textContent;root.querySelector('[data-lb-stock]').textContent=root.querySelector(available?'[data-lb-label-available]':'[data-lb-label-unavailable]').textContent;const url=new URL(window.location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);};select.addEventListener('change',update);});}
bindLimitlessProducts();document.addEventListener('shopify:section:load',bindLimitlessProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
